import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRouter } from "vue-router";
import { useUserStore } from "../stores/userStore";
import { useToast } from "../composables/useToast";
import AuthForm from "@/components/AuthForm.vue";
import Toast from "primevue/toast";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignInPage',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const { showError } = useToast();

const handleSignIn = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  try {
    await userStore.login(email, password);
    router.push("/");
  } catch (error) {
    console.error("Sign in failed:", error);
    showError("로그인에 실패했습니다. 이메일과 비밀번호를 확인해주세요.");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AuthForm, {
      title: "로그인",
      submitLabel: "로그인",
      footerLink: "/signup",
      footerText: "계정이 없으신가요? 회원가입",
      onSubmit: handleSignIn
    }),
    _createVNode(_unref(Toast), { position: "top-right" })
  ]))
}
}

})